<div class="sidebar-main">
    <div class="sidebar-header">
        <div class="logo-icon">
            <app-icon path="assets/images/common/logo.svg" />
        </div>
    </div>
    <div class="sidebar-content scrollbar-2">
        <div class="menu-wrapper">
            <div class="particular-menu" *ngFor="let menu of menus" [ngClass]="{active: isMenuActive(menu)}" (click)="goToMenu(menu.link)">
                <div class="menu-icon">
                    <app-icon [path]="isMenuActive(menu) ? menu.activeIcon : menu.icon"></app-icon>
                </div>
                <div class="menu-title">{{menu.title | translate}}</div>
            </div>
        </div>
    </div>
    <div class="sidebar-footer">
        <div class="left-section">
            <div class="profile-image">
                <img [src]="profilePic" alt="">
            </div>
            <div class="profile-detail">
                <div class="username">{{storageService.username}}</div>
                <!-- <div class="account-status" (click)="openConfirmPasswordDialog()">{{'changePassword' | translate}}</div> -->
            </div>
        </div>
        <div class="right-section">
            <div class="logout-icon" (click)="logout()">
                <img src="assets/images/common/logout-icon.svg" alt="">
            </div>
        </div>
    </div>
</div>